import { QaroniEnumInformation } from '../qaroni-enum-information/qaroni-enum-information';

export enum LanguageEnum {
  es = 'es',
  gl = 'gl',
}

export const LanguageEnumArray = [LanguageEnum.es, LanguageEnum.gl];

export const LanguageEnumInfo: QaroniEnumInformation<LanguageEnum> = {
  [LanguageEnum.es]: {
    name: 'Español',
  },

  [LanguageEnum.gl]: {
    name: 'Galego',
  },
};

export const LANGUAGE_DEFAULT = LanguageEnum.gl;
